import { render } from "./PromoEmptyBox.vue?vue&type=template&id=840caa72&scoped=true"
import script from "./PromoEmptyBox.vue?vue&type=script&lang=js"
export * from "./PromoEmptyBox.vue?vue&type=script&lang=js"

import "./PromoEmptyBox.vue?vue&type=style&index=0&id=840caa72&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840caa72"]])

export default __exports__